/* eslint-disable */
import _m0 from "protobufjs/minimal";

export const protobufPackage = "spotlight_driver";

/**
 * This file automatically generated by skymarshal.
 * DO NOT MODIFY BY HAND!!!!
 */

export interface SpotlightOnOff {
}

export enum SpotlightOnOff_Enum {
  UNKNOWN = 0,
  ON = 1,
  OFF = 2,
  UNRECOGNIZED = -1,
}

export function spotlightOnOff_EnumFromJSON(object: any): SpotlightOnOff_Enum {
  switch (object) {
    case 0:
    case "UNKNOWN":
      return SpotlightOnOff_Enum.UNKNOWN;
    case 1:
    case "ON":
      return SpotlightOnOff_Enum.ON;
    case 2:
    case "OFF":
      return SpotlightOnOff_Enum.OFF;
    case -1:
    case "UNRECOGNIZED":
    default:
      return SpotlightOnOff_Enum.UNRECOGNIZED;
  }
}

export function spotlightOnOff_EnumToJSON(object: SpotlightOnOff_Enum): string {
  switch (object) {
    case SpotlightOnOff_Enum.UNKNOWN:
      return "UNKNOWN";
    case SpotlightOnOff_Enum.ON:
      return "ON";
    case SpotlightOnOff_Enum.OFF:
      return "OFF";
    case SpotlightOnOff_Enum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

function createBaseSpotlightOnOff(): SpotlightOnOff {
  return {};
}

export const SpotlightOnOff = {
  encode(_: SpotlightOnOff, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SpotlightOnOff {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSpotlightOnOff();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): SpotlightOnOff {
    return {};
  },

  toJSON(_: SpotlightOnOff): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<SpotlightOnOff>, I>>(base?: I): SpotlightOnOff {
    return SpotlightOnOff.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SpotlightOnOff>, I>>(_: I): SpotlightOnOff {
    const message = createBaseSpotlightOnOff();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };
